export default {
  authorization: 'Авторизация',
  registration: 'Регистрация',
  by_phone_number: 'По номеру телефона',
  by_iin: 'По ИИН',
  phone_number: 'Номер телефона',
  iin: 'ИИН',
  password: 'Пароль',
  login: 'Войти',
  forgot_password: 'Забыли пароль?',
  further: 'Далее',
  send: 'Отправить',
  sms_verification_cod: 'Код смс верификации',
  send_again: 'Отправить снова через:',
  seconds: 'секунды',
  send_code_again: 'Отправить код снова',
  incorrect_code: 'Неверный код',
  name: 'Имя',
  surname: 'Фамилия',
  middle_name: 'Отчество',
  date_birth: 'Дата рождения',
  male: 'Мужской',
  female: 'Женский',
  repeat_password: 'Повторите пароль еще раз',
  referral_code: 'Реферальный код',
  i_agree: 'Согласен с Правилами сервиса',
  password_recovery: 'Восстановление пароля',
  by_phone: 'По телефону',
  by_email: 'По email',
  restore: 'Восстановить',
  bonuse: 'Бонусов',
  status: 'Статус',
  main: 'Главная',
  about: 'О ломбарде',
  our_services: 'Наши услуги',
  guide: 'Гид',
  my_pawnshop: 'Мой ломбард',
  settings: 'Настройки',
  bonuses: 'Бонусы',
  referral: 'Реферальная',
  go_out: 'Выйти',
  russian_language: 'Русский язык',
  kazakh_language: 'Казахский язык',
  my_office: 'Мой кабинет',
  your_town: 'Ваш город',
  no: 'Нет',
  yes: 'Да',
  text_1: 'НЕ ХОЧЕШЬ СТОЯТЬ В ОЧЕРЕДИ?',
  text_2: 'Тогда наше мобильное приложение СЕЙФ ломбард как раз для тебя!',
  almaty: 'Алматы',
  developed: 'Разработано в Mars Studio',
  seif: '2021 © ТОО «Сейф-Ломбард»',
  contact_us: 'Связаться с нами',
  your_name: 'Ваше имя',
  email_address: 'Email адрес',
  contact_number: 'Контактный телефон',
  message_text: 'Текст сообщения',
  write_us: 'Написать нам',
  head_office: 'Головной офис',
  text_3: 'Республика Казахстан, <br /> г. Алматы, Богенбай батыра, 156',
  renewal_text: 'Продление за третье лицо',
  ticket_number: 'Номер залогового билета',
  text_4: 'Вы так же можете продлить залоговый билет используя:',
  mobile_app: 'мобильное приложение',
  telegram_bot: 'telegram бот',
  qiwi_terminals: 'терминалы Qiwi',
  kassa_24: 'Касса 24',
  ticket_number_2: 'Залоговый билет №',
  date_issue: 'Дата выдачи',
  maturity_date: 'Дата погашения',
  credit_amount: 'Сумма кредита',
  amount_fine: 'Сумма штрафа',
  parameters: 'Параметры',
  minimum: 'Минимально',
  day: 'дня',
  days_extension: 'Дней продления',
  to_pay: 'К оплате:',
  tg: 'тг',
  pay: 'Оплатить',
  about_safe: 'О сейф ломбарде',
  years: 'лет',
  financial_market: 'на финансовом рынке',
  branches: 'отделений',
  all_over_Kazakhstan: 'по всему Казахстану',
  clients: 'клиентов',
  text_5: 'которым мы помогли в трудное время',
  text_6: 'Наш ломбард делает все возможное, для удобства своих клиентов',
  referral_system: 'реферальная система',
  loyalty_program: 'программа лояльности',
  social: 'Мы в социальных сетях',
  news: 'Новости',
  text_7: 'Отправьте нам на почту свое резюме, мы обязательно его рассмотрим',
  videos: 'Видео-ролики',
  cooperation: 'Сотрудничество',
  text_8:
    'Сейф-Ломбард рассмотрит предложения по аренде коммерческих помещений в местах с хорошей проходимостью, предпочтительно на первом этаже на взаимовыгодных условиях.',
  text_9: 'Для вас ответ оказался полезным?',
  thanks_tip: 'Спасибо за отзыв!',
  details: 'Подробнее',
  contact: 'Связаться',
  services: 'Услуги',
  to_contact_us: 'Связаться с нами',
  page: 'Страница',
  other_news: 'Другие Новости',
  auto: 'Под залог автомобилей',
  fur_products: 'Под залог меховых изделий',
  jewelry: 'Под залог ювелирных изделий',
  text_10: 'Жми, чтобы попасть наверх страницы',
  back_site: 'Вернутся на сайт',
  text_11: 'Бонусы для увеличения суммы кредита при выдаче',
  text_12:
    'В зависимости от вашей кредитной истории рассчитывается категория и количество накопленных бонусов. Пользуйтесь услугами, получайте бонусы и при получении кредита, увеличивайте свою расценку.',
  active: 'Активные',
  all: 'Все',
  text_13: 'Список залоговых билетов пуст',
  maturity_date: 'Дата погашения',
  expired: 'Просрочен',
  days: 'Дней',
  extend: 'Продлить',
  back: 'Назад',
  mortgaged_property: 'Залоговое имущество',
  prolongation: 'Пролонгация',
  use_SLT: 'Использовать SLT',
  to_pay: 'К оплате',
  amount_payment: 'Cумма оплаты',
  vendor_comission: 'Комиссия платежного оператора',
  add_card: 'Добавить карту',
  another_card: 'Другой картой',
  payment_successful: 'Оплата прошла успешно',
  payment_failed: 'Оплата не прошла',
  referral_system_2: 'Реферальная система',
  referral: 'Реферал',
  specify: 'Указать',
  text_14:
    'Для активации реферальной системы необходимо указать код клиента ломбарда, который уже зарегистрирован в приложении и имеет свой реферальный код либо обратиться в отделение ломбарда.',
  text_15:
    'Отправьте другу свой реферальный код – как только друг зарегистрируется, система активируется. Вы начнете получать деньги (SLT): <br /> Кешбек вы получаете от суммы оплаченных процентов: <br /> 1ый уровень (ваши кредиты) – 10% <br /> 2ой уровень (от тех, кого вы пригласили) – 5% <br /> 3ий уровень (от тех, кого пригласил 2ой уровень) – 3% <br /> С помощью этих денег (SLT), вы можете оплачивать проценты, но не более 50% от суммы оплаты.',
  referral_code_changed: 'Ваш реферальный код изменен',
  city: 'Город',
  gender: 'Пол',
  address_residence: 'Адрес проживания',
  pushkin: 'Пушкина 88',
  text_16:
    'Отправьте другу данный реферальный код – как только друг зарегистрируется, система активируется. Вы начнете получать деньги (SLT):<br> Кешбек вы получаете от суммы оплаченных процентов:<br> 1ый уровень (ваши микрокредиты) – 10%<br> 2ой уровень (от тех, кого вы пригласили) – 5%<br> 3ий уровень (от тех, кого пригласил 2ой уровень) – 3%<br> С помощью этих денег (SLT), вы можете оплачивать проценты, но не более 50% от суммы оплаты.',
  change_password: 'Cмена пароля',
  current_password: 'Текущий пароль',
  new_password: 'Новый пароль',
  re_new_password: 'Повторно новый пароль',
  save: 'Сохранить',
  change_email: 'Изменить Email',
  emai_changed: 'Ваш email изменен',
  password_changed: 'Ваш пароль изменен',
  my: 'Мой',
  office: 'кабинет',
  day_d: 'д.',
  search: 'Поиск',
  new_email: 'Новый email',
  rollover_amount: 'Сумма продления',
  title_main: 'Сейф Ломбард',
  home_link:
    'Лицензия на осуществление микрофинансовой деятельности номер 02.21.0004.L. от 10.03.2021 г.',
  about_link: 'Нормативное регулирование микрокредитования',
  about_link2:
    'Стандартные условия договора о предоставлении микрокредита и о залоге вещей в ломбарде (Договор присоединения)',
  about_link3: 'Годовая финансовая отчетность за 2020 год (рус)',
  about_link4: 'Годовая финансовая отчетность за 2020 год (eng)',
  about_link5: 'Годовая финансовая отчетность за 2021 год (рус)',
  about_link6: 'Годовая финансовая отчетность за 2021 год (eng)',
  about_link7: 'Годовая финансовая отчетность за 2022 год (рус)',
  about_link8: 'Годовая финансовая отчетность за 2022 год (eng)'
}



// WEBPACK FOOTER //
// ./src/lang/ru.js